export enum InformationalType {
  INTEREST_RATE = "interest_rate",
}

export type InformationalStatusType = Record<InformationalType, boolean>;
